import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';

export const radioButtonVariants = cva('flex gap-c', {
  variants: {
    variant: {
      vertical: 'flex-col',
      horizontal: 'flex-row',
    },
  },
  defaultVariants: {
    variant: 'horizontal',
  },
});

export type RadioButtonVariants = VariantProps<typeof radioButtonVariants>;
